import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo, useCallback } from "react";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
import { CopyAllButton } from "~/components/AssetModalV2/Content/Panel/components/CopyAllButton";
import { JumpToDropdown } from "~/components/AssetModalV2/Content/Panel/components/JumpToDropdown";
export const ChapterVideoInfo = /*#__PURE__*/ memo((param)=>{
    let { chapters, seekToChapter, activeChapterIndex } = param;
    const { setShowContentLeftPanel } = useAssetModalPanel();
    const onClose = useCallback(()=>{
        setShowContentLeftPanel(false);
    }, [
        setShowContentLeftPanel
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex justify-between",
        children: [
            /*#__PURE__*/ _jsx(JumpToDropdown, {
                chapters: chapters,
                seekToChapter: seekToChapter,
                activeChapterIndex: activeChapterIndex
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ _jsx(CopyAllButton, {
                        chapters: chapters
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mx-1 h-6 w-px rounded-2 bg-grey-5"
                    }),
                    /*#__PURE__*/ _jsx(IconButton, {
                        appearance: "ghost",
                        color: "grey",
                        "data-testid": "CHAPTERS_PANEL_CLOSE",
                        icon: Close,
                        label: "Close",
                        onClick: onClose,
                        size: "small"
                    })
                ]
            })
        ]
    });
});
ChapterVideoInfo.displayName = "ChapterVideoInfo";
